import { yupResolver } from '@hookform/resolvers/yup';
import React, { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { ScrollView, View } from 'react-native';
import { Footer, Input, Select, Text } from '~/components';

import * as yup from 'yup';
import { isBirthDateValid, isCellPhone } from '~/utils/yup';
import { useCreateAccountForm } from '~/stores';
import type { CreateAccuntStepsProps } from '../..';

interface StepFormData {
  firstName: string;
  lastName: string;
  gender: string;
  birthDate: string;
  cellphone: string;
}

export const schema = yup
  .object()
  .shape({
    firstName: yup.string().required('Este campo é obrigatório'),
    lastName: yup.string().required('Este campo é obrigatório'),
    gender: yup.string().required('Este campo é obrigatório'),
    cellphone: isCellPhone(),
    birthDate: isBirthDateValid({}),
  })
  .required();

const PersonalInfo: React.FC<CreateAccuntStepsProps> = ({ onContinue }) => {
  const { setPersonalInfo } = useCreateAccountForm();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<StepFormData>({
    resolver: yupResolver(schema),
  });

  const onSubmit = useCallback(
    (data: StepFormData) => {
      setPersonalInfo(data);
      onContinue?.();
    },
    [onContinue, setPersonalInfo]
  );

  return (
    <ScrollView
      contentContainerStyle={{
        justifyContent: 'space-between',
        flexGrow: 1,
        paddingBottom: 70,
      }}
      showsVerticalScrollIndicator={false}
      className="lg:w-[450px]"
    >
      <Text className="text-[22px] text-center text-gray-700 mt-6 mb-14">
        Agora, informe os seus{' '}
        <Text className="text-primary-600 font-medium">dados</Text>
      </Text>

      <View className="mb-10">
        <Input
          control={control}
          name="firstName"
          label="Nome"
          placeholder="Nome"
          keyboardType="ascii-capable"
          error={errors.firstName?.message}
          maxLength={100}
        />

        <Input
          control={control}
          name="lastName"
          label="Sobrenome"
          placeholder="Sobrenome"
          keyboardType="ascii-capable"
          error={errors.lastName?.message}
          maxLength={100}
        />

        <Select
          control={control}
          name="gender"
          label="Gênero"
          placeholder="Selecione o seu gênero"
          error={errors.gender?.message}
          items={[
            { label: 'Masculino', value: 'male' },
            { label: 'Feminino', value: 'female' },
            { label: 'Não informado', value: 'notinfo' },
          ]}
        />

        <Input
          control={control}
          name="birthDate"
          label="Data de nascimento"
          placeholder="Data de nascimento"
          keyboardType="number-pad"
          error={errors.birthDate?.message}
          maskConfig={{ type: 'custom', mask: '99/99/9999' }}
        />

        <Input
          control={control}
          name="cellphone"
          label="Celular"
          placeholder="Celular"
          keyboardType="number-pad"
          error={errors.cellphone?.message}
          maskConfig={{ type: 'cel-phone' }}
        />
      </View>

      <Footer
        noPadding
        onSubmit={handleSubmit(onSubmit)}
        buttonLabel="Próximo"
      />
    </ScrollView>
  );
};

export default PersonalInfo;
